import { computed } from 'vue';
import { useStore } from 'vuex';

export function useAuth() {
  const store = useStore();

  const user = computed(() => store.state.auth.user);
  const loading = computed(() => store.state.auth.loading);
  const error = computed(() => store.state.auth.error);
  const isAuthenticated = computed(() => store.getters['auth/isAuthenticated']);
  const userRole = computed(() => store.getters['auth/userRole']);

  const login = (payload) => store.dispatch('auth/login', payload);
  const register = (payload) => store.dispatch('auth/register', payload);
  const logout = () => store.dispatch('auth/logout');

  return {
    user,
    loading,
    error,
    isAuthenticated,
    userRole,
    login,
    register,
    logout,
  };
}


